import { useEffect } from 'react'

const useMount = (func) => {
  useEffect(() => {
    return func()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export default useMount;